module.exports = __webpack_public_path__ + "static/media/login-background2-tw.77ba9850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-background2-tw.png
// module id = 1100
// module chunks = 110